// eslint-disable-next-line
import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { useTheme } from "../context/ThemeContext";
import { useTranslation } from "react-i18next";
import Container from "../components/Container";
import usePortfolioStore from "../store/store";
import DriveImage from "../components/DriveImage";
import RingGallery from "../components/homePage/HeroGallery";
import ExploreSection from "../components/homePage/exploreSection";
import Loading from "../components/loading";

const Home = () => {
  const { colors } = useTheme();
  const { t, i18n } = useTranslation(["home", "header", "common"]);
  const projects = usePortfolioStore((s) => s.projects || []);
  const skills = usePortfolioStore((s) => s.skills || []);
  const [showAllSkills, setShowAllSkills] = useState(false);
  const [activeCardId, setActiveCardId] = useState(null);

  const customSummaries = [
    {
      key: 1,
      text: "Welcome to my portfolio! I am an Associate Software Engineer and IOT professional in GUTs Investigation Security,ltd.  My technical foundation spans full-stack web development, Python, AWS cloud architecture, and proactive system maintenance, refined through diverse roles and internships at organizations like J.P. Morgan.",
    },
    {
      key: 2,
      text: "In management, I bring years of experience as an Assistant Branch Manager and Supervisor. I successfully directed daily business operations, analyzed financial data to guide strategy, led marketing campaigns, and mentored staff to build cohesive, high-performing teams.",
    },
    {
      key: 3,
      text: "As a passionate educator, I have served as a Computer Technology Instructor, Secondary School Teacher, and Language Teacher. I excel at translating complex technical and linguistic concepts into engaging lessons, from establishing coding clubs to delivering personalized language instruction.",
    },
    {
      key: 4,
      text: "I am deeply committed to community well-being, having volunteered part-time as a Sexual Assault Victim Advocate to provide critical trauma-informed care and crisis counseling. I bring this same empathy, patience, and clear communication to my IT help-desk and technical support roles.",
    },
    {
      key: 5,
      text: "Beyond traditional engineering, I am a dedicated Quantum Computing and AI enthusiast. I continuously push my boundaries by exploring machine learning, deep neural networks, and digital graphic design, aiming to blend advanced theoretical concepts with practical, user-centric solutions.",
    },
    {
      key: 6,
      text: "Throughout my career, volunteering has been a cornerstone of my growth. Whether it's advocating for victims at the Mon Women Organization or teaching summer programs at the Mon Language Development Association, I am driven by a desire to empower others and build stronger, more resilient communities through education and support.",
    },
  ];

  const matchedSummary = customSummaries.find(
    (s) => s.key === activeCardId,
  )?.text;
  const displaySummary = matchedSummary || t("hero.summary");

  const certifications = usePortfolioStore((s) => s.certifications || []);
  const fetchProjectsRemote = usePortfolioStore((s) => s.fetchProjectsRemote);
  const fetchCertificationsRemote = usePortfolioStore(
    (s) => s.fetchCertificationsRemote,
  );
  const references = usePortfolioStore((s) => s.references || []);
  const fetchReferencesRemote = usePortfolioStore(
    (s) => s.fetchReferencesRemote,
  );
  const blogs = usePortfolioStore((s) => s.blogs || []);
  const fetchBlogsRemote = usePortfolioStore((s) => s.fetchBlogsRemote);
  const workExperiences = usePortfolioStore((s) => s.workExperiences || []);
  const fetchWorkRemote = usePortfolioStore((s) => s.fetchWorkRemote);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    const fns = [
      fetchProjectsRemote,
      fetchCertificationsRemote,
      fetchReferencesRemote,
      fetchBlogsRemote,
      fetchWorkRemote,
    ];

    const calls = fns.map((fn) =>
      typeof fn === "function" ? fn().catch(() => {}) : Promise.resolve(),
    );

    Promise.allSettled(calls).then(() => {
      if (mounted) setLoading(false);
    });

    return () => {
      mounted = false;
    };
  }, [
    fetchProjectsRemote,
    fetchCertificationsRemote,
    fetchReferencesRemote,
    fetchBlogsRemote,
    fetchWorkRemote,
  ]);

  const preview = (projects || []).slice(0, 6);
  const dateLocaleMap = {
    en: "en-US",
    cn: "zh-CN",
    th: "th-TH",
    my: "my-MM",
  };
  const activeDateLocale =
    dateLocaleMap[i18n.resolvedLanguage] || dateLocaleMap.en;
  const sections = [
    {
      key: "projects",
      title: t("explore.sections.projects.title"),
      path: "/projects",
      desc: t("explore.sections.projects.desc"),
    },
    {
      key: "educations",
      title: t("explore.sections.educations.title"),
      path: "/educations",
      desc: t("explore.sections.educations.desc"),
    },
    {
      key: "certifications",
      title: t("explore.sections.certifications.title"),
      path: "/certifications",
      desc: t("explore.sections.certifications.desc"),
    },
    {
      key: "workExperiences",
      title: t("explore.sections.workExperiences.title"),
      path: "/work-experiences",
      desc: t("explore.sections.workExperiences.desc"),
    },
    {
      key: "references",
      title: t("explore.sections.references.title"),
      path: "/references",
      desc: t("explore.sections.references.desc"),
    },
    {
      key: "blogs",
      title: t("explore.sections.blogs.title"),
      path: "/blogs",
      desc: t("explore.sections.blogs.desc"),
    },
  ];

  return (
    <Container className="overflow-x-hidden relative min-h-screen">
      {/* loading */}
      {loading ? (
        <Loading />
      ) : (
        <div className="pt-10 px-1 md:px-4">
          {/* HERO */}
          {/* <h2
          className={`  sm:mt-8 text-2xl sm:text-3xl md:text-3xl font-extrabold leading-tight ${colors.text.primary}`}
        >
          {t("header:title")}{" "}
          <span className="block text-base sm:text-lg md:text-base font-semibold mt-2">
            ({t("hero.role")})
          </span>
        </h2> */}
          <div className=" flex flex-col-reverse lg:flex-row lg:items-start lg:justify-between gap-1 ">
            <div className="w-full mt-5">
              <div className=" ">
                <div
                  style={{
                    position: "relative",
                    minHeight: "80px",
                    display: "flex",
                    alignItems: "flex-start",
                  }}
                >
                  <p
                    key={activeCardId || "default"}
                    className={`text-[13px]  md:text-base ${colors.text.secondary}`}
                    style={{
                      animation:
                        "dropAndFade 0.5s cubic-bezier(0.4, 0, 0.2, 1) forwards",
                    }}
                  >
                    {displaySummary}
                  </p>
                </div>
                <style>{`
                @keyframes dropAndFade {
                  0% { transform: translateY(-20px); opacity: 0; }
                  100% { transform: translateY(0); opacity: 1; }
                }
              `}</style>

                <div className="mt-8 flex flex-wrap gap-4">
                  <a
                    href="/resume.pdf"
                    target="_blank"
                    rel="noreferrer"
                    className={`inline-block text-xs sm:text-sm px-3 sm:px-4 py-1.5 sm:py-2 rounded-lg transition ${colors.button.primary}`}
                  >
                    {t("hero.downloadResume")}
                  </a>
                  <a
                    href="mailto:you@example.com"
                    className={`inline-block text-xs sm:text-sm px-3 sm:px-4 py-1.5 sm:py-2 rounded transition ${colors.text.muted} hover:${colors.text.secondary}`}
                  >
                    {t("hero.contact")}
                  </a>
                </div>
              </div>
            </div>

            <div className="w-full ">
              <div className="w-full  h-60 sm:h-70 ">
                {/* Debug: show first gallery image URL and a raw <img> to verify loading */}

                <RingGallery
                  radius={320}
                  autoRotate={true}
                  speed={0.3}
                  imageCount={18}
                  batchSize={3}
                  minVisible={0}
                  addCount={1}
                  removeCount={1}
                  colors={colors}
                  onCardClick={setActiveCardId}
                />
              </div>
            </div>
          </div>

          {/* SECTIONS */}
          <ExploreSection colors={colors} t={t} sections={sections} />

          {/* SKILLS (from store, show 8, expandable) */}
          <section className="max-w-7xl px-1 md:px-4 mt-3 md:mt-20 ">
            <h2
              className={`text-lg md:text-3xl font-bold mb-6 ${colors.text.primary}`}
            >
              {t("skills.title")}
            </h2>
            <div
              className={`flex flex-wrap gap-1 md:gap-3 transition-[max-height] duration-300 ease-in-out overflow-hidden min-w-0`}
              style={
                !showAllSkills && skills.length > 8
                  ? { maxHeight: "12rem" }
                  : showAllSkills && skills.length > 8
                    ? { maxHeight: "1000px" }
                    : {}
              }
            >
              {skills.length === 0 ? (
                <span className={`text-sm ${colors.text.secondary}`}>
                  {t("skills.empty")}
                </span>
              ) : (
                <>
                  {(showAllSkills ? skills : skills.slice(0, 8)).map(
                    (skill) => (
                      <span
                        key={skill.id || skill.name}
                        className={`px-3 sm:px-4 py-1 sm:py-1.5 text-xs sm:text-sm rounded-full ${colors.background.primary} border ${colors.border} ${colors.text.secondary} hover:${colors.background.secondary} transition break-words min-w-0`}
                        style={{
                          wordBreak: "break-word",
                          overflowWrap: "break-word",
                        }}
                      >
                        {skill.name}
                      </span>
                    ),
                  )}
                  {/* for seel all if do we cna see alll live in side the contaienr */}
                  {skills.length > 8 && (
                    <span
                      className={`px-3 sm:px-4 py-1 sm:py-1.5 text-xs sm:text-sm rounded-full ${colors.background.primary} border ${colors.border} ${colors.link.primary} hover:${colors.background.secondary} transition break-words min-w-0`}
                      style={{
                        wordBreak: "break-word",
                        overflowWrap: "break-word",
                      }}
                      onClick={() => setShowAllSkills((v) => !v)}
                    >
                      {showAllSkills
                        ? t("skills.showLess")
                        : t("skills.showAll")}
                    </span>
                  )}
                </>
              )}
            </div>
            {/*
            {skills.length > 8 && (
              <button
                className={`mt-2 px-3 py-1 text-sm rounded ${colors.background.primary} border ${colors.border} ${colors.text.secondary}`}
                onClick={() => setShowAllSkills((v) => !v)}
              >
                {showAllSkills ? t("skills.showLess") : t("skills.showAll")}
              </button>
            )}*/}
          </section>

          {/* PROJECTS PREVIEW */}
          <section className="max-w-7xl mx-auto px-1 md:px-4 mt-3 md:mt-20">
            <div className="flex items-center justify-between mb-1 md:mb-6">
              <h2
                className={`text-lg md:text-3xl font-bold ${colors.text.primary}`}
              >
                {t("projects.title")}
              </h2>
              <Link
                to="/projects"
                className={`${colors.link.primary} py-1.5 md:py-2 rounded-lg text-xs md:text-sm transition`}
              >
                {t("actions.seeAll", { ns: "common" })}
              </Link>
            </div>

            {preview.length === 0 ? (
              <div
                className={`${colors.background.secondary} rounded-lg p-8 sm:p-12 text-center`}
              >
                <svg
                  className={`mx-auto h-10 w-10 sm:h-12 sm:w-12 ${colors.text.muted} mb-4`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1.5}
                    d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
                  />
                </svg>
                <p
                  className={`text-[11px] sm:text-xs md:text-sm ${colors.text.secondary}`}
                >
                  {t("projects.emptyTitle")}
                </p>
                <p className={`text-sm ${colors.text.muted} mt-2`}>
                  {t("projects.emptyDescription")}
                </p>
              </div>
            ) : (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
                {preview.map((p) => (
                  <article
                    key={p.id || p.name}
                    className={`${colors.background.primary} border ${colors.border} rounded-lg overflow-hidden hover:shadow-lg transition-shadow`}
                  >
                    <div className="w-full h-36 sm:h-40 bg-gradient-to-br from-sky-400 to-blue-600 rounded-t-lg overflow-hidden shadow-sm">
                      <DriveImage
                        src={p.projectsImageUrl}
                        alt={p.name}
                        className="w-full h-full object-cover"
                        fallback={
                          <div className="w-full h-full flex items-center justify-center">
                            <svg
                              className="w-10 h-10 text-white opacity-50"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={1.5}
                                d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                              />
                            </svg>
                          </div>
                        }
                      />
                    </div>
                    <div className="p-3 sm:p-4">
                      <h3
                        className={`text-sm sm:text-base md:text-lg font-semibold ${colors.text.primary}`}
                      >
                        {p.name}
                      </h3>
                      <p
                        className={`text-[11px] sm:text-xs md:text-sm ${colors.text.secondary} mt-2 line-clamp-3`}
                      >
                        {p.description}
                      </p>
                      <div className="mt-4 flex items-center justify-between">
                        <Link
                          to={`/projects/${p.id || ""}`}
                          className={`text-sm ${colors.text.primary} px-3 py-1 rounded transition`}
                        >
                          {t("projects.viewDetails")}
                        </Link>
                        {p.tags && (
                          <span className={`text-xs ${colors.text.muted}`}>
                            {p.tags}
                          </span>
                        )}
                      </div>
                    </div>
                  </article>
                ))}
              </div>
            )}
          </section>

          {/* EXPERIENCE TIMELINE */}
          <section className="max-w-7xl mx-auto px-1 md:px-4 mt-5 md:mt-20">
            <div className="flex items-center justify-between mb-1 md:mb-6">
              <h2
                className={`text-lg md:text-3xl font-bold ${colors.text.primary}`}
              >
                {t("work.title")}
              </h2>
              {workExperiences.length > 4 && (
                <Link
                  to="/work-experiences"
                  className={`${colors.link.primary} py-1.5 md:py-2 rounded-lg text-xs md:text-sm transition`}
                >
                  {t("actions.seeAll", { ns: "common" })}
                </Link>
              )}
            </div>
            {workExperiences.length === 0 ? (
              <div
                className={`${colors.background.secondary} rounded-lg p-6 sm:p-8 text-center`}
              >
                <p
                  className={`text-[11px] sm:text-xs md:text-sm ${colors.text.secondary}`}
                >
                  {t("work.empty")}
                </p>
              </div>
            ) : (
              <div className="space-y-1 sm:space-y-4">
                {workExperiences.slice(0, 4).map((exp, idx) => (
                  <div
                    key={exp.id || idx}
                    className={`${colors.background.primary} border ${colors.border} rounded-lg p-3 md:p-5 hover:shadow-md transition-shadow`}
                  >
                    <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-2 sm:gap-4">
                      <div className="flex-1">
                        <h3
                          className={`text-sm sm:text-base md:text-lg font-semibold ${colors.text.primary}`}
                        >
                          {exp.position}
                        </h3>
                        <p
                          className={`text-[11px] sm:text-xs md:text-sm ${colors.text.secondary} mt-1`}
                        >
                          {exp.company}
                        </p>
                      </div>
                      <p
                        className={`text-xs sm:text-sm ${colors.text.muted} whitespace-nowrap`}
                      >
                        {exp.startDate && new Date(exp.startDate).getFullYear()}{" "}
                        -{" "}
                        {exp.endDate
                          ? new Date(exp.endDate).getFullYear()
                          : t("work.present")}
                      </p>
                    </div>
                    {exp.description && (
                      <p
                        className={`text-[11px] sm:text-xs md:text-sm ${colors.text.secondary} mt-3 line-clamp-2`}
                      >
                        {exp.description}
                      </p>
                    )}
                  </div>
                ))}
              </div>
            )}
          </section>

          {/* FEATURED BLOG POSTS */}
          <section className="max-w-7xl mx-auto px-1 md:px-4 mt-8 md:mt-20">
            <div className="flex items-center justify-between mb-1 md:mb-6">
              <h2
                className={`text-lg md:text-3xl font-bold ${colors.text.primary}`}
              >
                {t("blogs.title")}
              </h2>
              <Link
                to="/blogs"
                className={`${colors.link.primary} py-1.5 md:py-2 rounded-lg text-xs md:text-sm transition`}
              >
                {t("actions.seeAll", { ns: "common" })}
              </Link>
            </div>

            {blogs.length === 0 ? (
              <div
                className={`${colors.background.secondary} rounded-lg p-8 sm:p-12 text-center`}
              >
                <p
                  className={`text-[11px] sm:text-xs md:text-sm ${colors.text.secondary}`}
                >
                  {t("blogs.empty")}
                </p>
              </div>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
                {blogs.slice(0, 3).map((post) => (
                  <article
                    key={post.id}
                    className={`${colors.background.primary} border ${colors.border} rounded-lg overflow-hidden hover:shadow-lg transition-shadow flex flex-col`}
                  >
                    {post.blogImageUrl && (
                      <div className="w-full h-32 sm:h-40 bg-gradient-to-br from-purple-400 to-pink-600">
                        <DriveImage
                          src={post.blogImageUrl}
                          alt={post.title}
                          className="w-full h-full object-cover"
                          fallback={
                            <div className="w-full h-full bg-gradient-to-br from-purple-400 to-pink-600" />
                          }
                        />
                      </div>
                    )}
                    <div className="p-3 sm:p-4 flex-1 flex flex-col">
                      <h3
                        className={`text-base sm:text-lg md:text-xl font-semibold ${colors.text.primary}`}
                      >
                        {post.title}
                      </h3>
                      <p
                        className={`text-xs sm:text-sm ${colors.text.muted} mt-1`}
                      >
                        {post.date
                          ? new Date(post.date).toLocaleDateString(
                              activeDateLocale,
                              {
                                year: "numeric",
                                month: "short",
                                day: "numeric",
                              },
                            )
                          : t("blogs.noDate")}
                      </p>
                      <p
                        className={`text-[11px] sm:text-xs md:text-sm ${colors.text.secondary} mt-2 line-clamp-2 flex-1`}
                      >
                        {post.summary}
                      </p>
                      <Link
                        to={`/blogs/${post.id || ""}`}
                        className={`text-sm ${colors.text.primary} px-3 py-1 rounded transition inline-block mt-3 w-fit`}
                      >
                        {t("blogs.readMore")}
                      </Link>
                    </div>
                  </article>
                ))}
              </div>
            )}
          </section>

          {/* CERTIFICATIONS SECTION (from store) */}
          <section className="max-w-7xl mx-auto px-1 md:px-4 mt-5 md:mt-20">
            <div className="flex items-center justify-between mb-1 md:mb-6">
              <h2
                className={`text-lg md:text-3xl font-bold ${colors.text.primary}`}
              >
                {t("certifications.title")}
              </h2>
              {certifications.length > 5 && (
                <Link
                  to="/certifications"
                  className={`${colors.link.primary} py-1.5 md:py-2 rounded-lg text-xs md:text-sm transition`}
                >
                  {t("actions.seeAll", { ns: "common" })}
                </Link>
              )}
            </div>
            {certifications.length === 0 ? (
              <div
                className={`${colors.background.secondary} rounded-lg p-6 sm:p-8 text-center`}
              >
                <p
                  className={`text-[11px] sm:text-xs md:text-sm ${colors.text.secondary}`}
                >
                  {t("certifications.empty")}
                </p>
              </div>
            ) : (
              <div className="space-y-2 sm:space-y-6">
                {certifications.slice(0, 5).map((cert) => (
                  <div
                    key={cert.id}
                    className={`${colors.background.primary} border ${colors.border} rounded-lg p-4 sm:p-6 hover:shadow-md transition-shadow`}
                  >
                    <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-2 sm:gap-4">
                      <div className="flex-1">
                        <h3
                          className={`text-sm sm:text-base md:text-lg font-semibold ${colors.text.primary}`}
                        >
                          {cert.name}
                        </h3>
                        <p
                          className={`text-[11px] sm:text-xs md:text-sm ${colors.text.secondary} mt-1`}
                        >
                          {cert.issuer}
                        </p>
                      </div>
                      <p
                        className={`text-xs sm:text-sm ${colors.text.muted} whitespace-nowrap`}
                      >
                        {cert.year}
                      </p>
                    </div>
                    {cert.description && (
                      <p
                        className={`text-[11px] sm:text-xs md:text-sm ${colors.text.secondary} mt-3 line-clamp-2`}
                      >
                        {cert.description}
                      </p>
                    )}
                  </div>
                ))}
              </div>
            )}
          </section>

          <section className="max-w-6xl mx-auto px-1 md:px-4 mt-8 md:mt-20">
            <div className="flex items-start sm:items-center justify-between mb-1 md:mb-6">
              <h2
                className={`text-lg md:text-3xl font-bold ${colors.text.primary}`}
              >
                {t("references.title")}
              </h2>
              <Link
                to="/references"
                className={`${colors.link.primary} py-1.5 md:py-2 rounded-lg text-xs md:text-sm transition`}
              >
                {t("actions.seeAll", { ns: "common" })}
              </Link>
            </div>
            {references.length === 0 ? (
              <div
                className={`${colors.background.secondary} rounded-lg p-6 sm:p-8 text-center`}
              >
                <p
                  className={`text-[11px] sm:text-xs md:text-sm ${colors.text.secondary}`}
                >
                  {t("references.empty")}
                </p>
              </div>
            ) : (
              <div className="flex justify-center w-full">
                <div className="swiper-container w-full">
                  <Swiper
                    modules={[Pagination]}
                    pagination={{ clickable: true }}
                    spaceBetween={20}
                    slidesPerView={1}
                    className=""
                  >
                    {references.map((ref) => (
                      <SwiperSlide key={ref.id}>
                        <div
                          className={`${colors.background.primary} border ${colors.border} rounded-lg p-4 sm:p-6 shadow hover:shadow-lg transition h-full flex flex-col items-center text-center`}
                        >
                          <div>
                            <div className="flex flex-row items-center gap-3 sm:gap-4 mb-3 sm:mb-4 w-full">
                              <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full overflow-hidden flex-shrink-0 bg-gradient-to-br from-sky-400 to-blue-600 flex items-center justify-center">
                                <DriveImage
                                  src={ref.referenceImageUrl}
                                  alt={ref.name}
                                  className="w-full h-full object-cover"
                                  fallback={
                                    <svg
                                      className="w-6 h-6 text-white"
                                      fill="currentColor"
                                      viewBox="0 0 24 24"
                                    >
                                      <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                                    </svg>
                                  }
                                />
                              </div>
                              <div className="w-full text-center">
                                <h3
                                  className={`text-xs sm:text-sm md:text-base font-semibold ${colors.text.primary}`}
                                >
                                  {ref.name}
                                </h3>
                                {ref.relationship && (
                                  <p
                                    className={`text-[11px] sm:text-xs ${colors.text.secondary}`}
                                  >
                                    {ref.relationship}
                                  </p>
                                )}
                                {ref.company && (
                                  <p
                                    className={`text-[11px] sm:text-xs ${colors.text.muted}`}
                                  >
                                    {ref.company}
                                  </p>
                                )}
                              </div>
                            </div>
                          </div>
                          {ref.testimonial && (
                            <p
                              className={`text-[11px] sm:text-xs md:text-sm italic ${colors.text.secondary} mt-2 line-clamp-4`}
                            >
                              {ref.testimonial}
                            </p>
                          )}
                          {ref.contact && (
                            <p
                              className={`text-xs sm:text-sm mt-2 ${colors.text.muted}`}
                            >
                              {ref.contact}
                            </p>
                          )}
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </div>
            )}
          </section>
        </div>
      )}
    </Container>
  );
};

export default Home;
